<template>
  <div class="grow">
    <Damages v-if="booking && car" :car-id="car.id" :booking-id="booking.id" />
    <div class="mt-10 flex justify-end">
      <ButtonNext type="submit" :disabled="hasUnsentDamages" @click.prevent="handleSubmit">
        {{ t('saveAndNext') }}
      </ButtonNext>
    </div>
  </div>
</template>

<script setup lang="ts">
import Damages from '@/components/booking-forms/damages/Damages.vue';
import { useUnsentDamages } from '@/hooks/use-unsent-damages';
import { useRoute } from 'vue-router';
import ButtonNext from '@/components/buttons/ButtonNext.vue';
import { useBooking, useUpdateBooking } from '@/queries/use-bookings';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useProcessNavigation } from '@/hooks/use-process-step-tracking';

const { t } = useI18n();
const route = useRoute();
const { goToNext } = useProcessNavigation();

const { data: booking } = useBooking(route.params.id as string);
const car = computed(() => booking.value?.allocations[booking.value.allocations.length - 1].car);
// A return completed before its damage arrives would release the deposit.
const { hasUnsentDamages } = useUnsentDamages(() => car.value?.id);

const handleSubmit = () => {
  goToNext();
};
</script>
<i18n lang="json">
{
  "en": {
    "back": "back to customer bookings overview"
  },
  "de": {
    "back": "Zurück zur Buchungsübersicht"
  },
  "es": {
    "back": "volver a la vista general de reservas del cliente"
  }
}
</i18n>
